/**
 * Build identity, injected by Vite at build time (see vite.config.js).
 *
 * The same values are on the served index.html as `app-version` / `app-commit`
 * meta tags and as `window.__NAM_EVENTS_VERSION__` / `window.__NAM_EVENTS_COMMIT__`,
 * so a deployed environment can be identified without rendering the app.
 */
export const APP_VERSION: string = __APP_VERSION__;

/** Short git sha of the built commit, or "unknown" when the build had no git checkout. */
export const APP_COMMIT: string = __APP_COMMIT__;

/** Display label, e.g. "v1.0.0 (7704504)", falling back to "v1.0.0". */
export const APP_BUILD: string =
    APP_COMMIT === "unknown" ? `v${APP_VERSION}` : `v${APP_VERSION} (${APP_COMMIT})`;
